// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"AccommodationsList_pageHeader__3MOed"};